/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  DeleteCertificateRequestMutationRequest,
  DeleteCertificateRequestMutationResponse,
} from "../types/DeleteCertificateRequest.ts"

export const deleteCertificateRequestMutationKey = () =>
  [{ url: "/v1/certificate-request/delete-certificate-request" }] as const

export type DeleteCertificateRequestMutationKey = ReturnType<
  typeof deleteCertificateRequestMutationKey
>

/**
 * @summary Delete certificate request
 * {@link /v1/certificate-request/delete-certificate-request}
 */
export async function deleteCertificateRequest(
  data: DeleteCertificateRequestMutationRequest,
  config: Partial<RequestConfig<DeleteCertificateRequestMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    DeleteCertificateRequestMutationResponse,
    ResponseErrorConfig<Error>,
    DeleteCertificateRequestMutationRequest
  >({
    method: "DELETE",
    url: `/v1/certificate-request/delete-certificate-request`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function deleteCertificateRequestMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<DeleteCertificateRequestMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = deleteCertificateRequestMutationKey()
  return mutationOptions<
    ResponseConfig<DeleteCertificateRequestMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteCertificateRequestMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return deleteCertificateRequest(data, config)
    },
  })
}

/**
 * @summary Delete certificate request
 * {@link /v1/certificate-request/delete-certificate-request}
 */
export function useDeleteCertificateRequest<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteCertificateRequestMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: DeleteCertificateRequestMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<DeleteCertificateRequestMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? deleteCertificateRequestMutationKey()

  const baseOptions = deleteCertificateRequestMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<DeleteCertificateRequestMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteCertificateRequestMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<DeleteCertificateRequestMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteCertificateRequestMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DeleteCertificateRequestMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteCertificateRequestMutationRequest },
    TContext
  >
}
